import { getDefaultHeaders } from "./utils";

export async function comicTextUpdateSpeaker(comicTextId, speakerName) {
  try {
    const headers = await getDefaultHeaders(true, true);
    const requestOptions = {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify({ speaker: speakerName }),
    };

    const url = `/api/comic-texts/${comicTextId}/speaker/`;
    
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error || `HTTP error ${response.status}`);
    }
    
    return await response.json();
  } catch (err) {
    console.error("Error updating speaker:", err);
    throw err;
  }
}
